<template>
	<div style="width:90%"> 
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					
					
					<el-form-item label="用户名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户名称"></el-input>
					</el-form-item>
					<el-form-item label="店铺名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入店铺名称"></el-input>
					</el-form-item>
					<!-- <el-form-item label="时间">
                        <div class="block">
                            <el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
                                :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </div>
                    </el-form-item> -->

					<el-form-item label="企业名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.enterpriseName" placeholder="请输入企业名称"></el-input>
					</el-form-item>
					<el-form-item label="项目名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.businessName" placeholder="请输入项目名称"></el-input>
					</el-form-item>
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.checkState" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待审核" value="0">待审核</el-option>
							<el-option key="1" label="通过" value="1">通过</el-option>
							<el-option key="2" label="驳回" value="2">驳回</el-option>
						</el-select>
					</el-form-item>
					
				<!-- 	<el-form-item label="状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="停用" :value="0"></el-option>
							<el-option key="1" label="正常" :value="1"></el-option>
						</el-select>
					</el-form-item> -->

					<!-- <el-form-item label="店铺属性" class='tiny' cleartable>
						<el-select v-model="searchInfo.storeType" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="1" label="线上店铺" :value="0"></el-option>
							<el-option key="2" label="线下店铺" :value="1"></el-option>
						</el-select>
					</el-form-item> -->

					<el-form-item label="排序方式" class='tiny' cleartable>
						<el-select v-model="searchInfo.orderType" placeholder="默认创建时间降序">
							<el-option key="0" label="更新时间降序" value="0">更新时间降序</el-option>
							<el-option key="1" label="创建时间升序" value="1">创建时间升序</el-option>
							<el-option key="2" label="创建时间降序" value="2">创建时间降序</el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="dialogVisibleFun();title='新增'">新增店铺
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="storeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<el-table-column type="expand" >
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="项目名称">
							<span>{{ props.row.businessName }}</span>
						</el-form-item>
						<el-form-item label="企业名称"> 
							<span>{{ props.row.enterpriseName }}</span>
							
						</el-form-item>

						<el-form-item label="年度营业收入">
							<span>{{ props.row.businessIncome }} 万元</span>
							
						</el-form-item>
						<el-form-item label="同比增长">
							<span>{{ props.row.businessIncomeRate }} %</span>
						</el-form-item>
						<el-form-item label="净利润">
							<span>{{ props.row.netProfit }} 万元</span>
							
						</el-form-item>
						<el-form-item label="同比增长">
							<span>{{ props.row.netProfitRate }} %</span>
						</el-form-item>
						<el-form-item label="法人">
							<span style="margin-right:20px;">{{ props.row.legalPerson }} </span>
						
						</el-form-item>

						<el-form-item label="法人身份证">
							<span>{{props.row.cardNo?props.row.cardNo:'无'}}</span>
						</el-form-item>
						<el-form-item label="身份证正面">
							<el-button size="small" type="text" @click="findDetail(props.row.positiveImage,2)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="身份证反面">
							<el-button size="small" type="text" @click="findDetail(props.row.reverseImage,2)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="联系人">
							<span>{{props.row.contacts?props.row.contacts:'无'}}</span>
						</el-form-item>
						<el-form-item label="联系电话">
							<span>{{props.row.contactNumber?props.row.contactNumber:'无'}}</span>
						</el-form-item>
						<el-form-item label="所属行业">
							<span>{{props.row.industryAffiliation?props.row.industryAffiliation:'无'}}</span>
						</el-form-item>
						<el-form-item label="主营业务">
							<span>{{props.row.mainBusiness?props.row.mainBusiness:'无'}}</span>
						</el-form-item>
						
						<el-form-item label="经营范围">
							
							<el-button size="small" type="text" @click="findDetail(props.row.natureBusiness,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="税号">
							<span v-if="props.row.dutyParagraph">{{ props.row.dutyParagraph }}</span>
							<span v-else>无</span>
						</el-form-item>
						<el-form-item label="企业介绍">
							<el-button size="small" type="text" @click="findDetail(props.row.businessSituation,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="财务简况">
							<el-button size="small" type="text" @click="findDetail(props.row.financialOverview,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="IPO进程">
							<el-button size="small" type="text" @click="findDetail(props.row.ipoProcess,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="市值评估">
							<el-button size="small" type="text" @click="findDetail(props.row.marketValueAssessment,1)">点击查看</el-button>
						</el-form-item>
						
						
						
						
						<el-form-item v-if="props.row.status==2" label="驳回原因">
							<span>{{ props.row.reason }}</span>
						</el-form-item>
						

					</el-form>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="storeId" label="店铺ID" align="center" :show-overflow-tooltip="true" width="70px">
			</el-table-column> -->
			<el-table-column prop="enterpriseName" label="企业名称" align="center" :show-overflow-tooltip="true" width="80px">
				
			</el-table-column>
			<el-table-column prop="storeName" label="关联店铺" align="center" :show-overflow-tooltip="true">
				
			</el-table-column>
			<el-table-column prop="username" label="关联用户" align="center" :show-overflow-tooltip="true">
				
			</el-table-column>
			<el-table-column prop="businessName" label="项目名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="businessLogo" label="项目LOGO" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.businessLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
				</template>
			</el-table-column>
			
			<el-table-column prop="legalPerson" label="法人" align="center" :show-overflow-tooltip="true" width="80px">
				
			</el-table-column>
			<el-table-column prop="registeredCapital" label="注册资本" align="center" :show-overflow-tooltip="true" width="80px">
				
			</el-table-column>
		
			<el-table-column prop="monetaryUnit" label="注册资本单位" align="center" :show-overflow-tooltip="true" width="80px">
				<template slot-scope="scope">
					<p v-if="scope.row.monetaryUnit == 1">人民币</p>
					<p v-if="scope.row.monetaryUnit == 2">港币</p>
					<p v-if="scope.row.monetaryUnit == 3">美元</p>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="地址" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<el-table-column prop="establishmentDate" label="设定日期" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column>
			<!-- <el-table-column prop="establishmentDate" label="设定日期" align="center" :show-overflow-tooltip="true"  width="110px">
			</el-table-column> -->
		
			<el-table-column prop="status" label="审核状态" align="center" :show-overflow-tooltip="true" width="80px">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0" style="color:#E6A23C;font-weight: bold;">待审核</p>
					<p v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">通过</p>
					<p v-if="scope.row.status==2" style="color:#F56C6C;font-weight: bold;">驳回</p>
				</template>
			</el-table-column>

			<!-- <el-table-column prop="status" label="店铺状态" align="center" :show-overflow-tooltip="true" width="80px">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0">停用</p>
					<p v-if="scope.row.status==1">正常</p>
				</template>
			</el-table-column> -->

			<el-table-column prop="createTime" label="注册时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column  label="操作"  fixed="right" align="center" width="200">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="dialogVisibleFun(scope.row);title='编辑'">编辑</el-button>
					
					<!-- <el-button size="small" type="text" @click="storeGoodsDialog(scope.row)">店铺商品</el-button> -->

					<!-- <el-button size="small" type="text" v-if="scope.row.status==1" @click="editStatusShow(scope.row)">
						{{scope.row.status ? '禁用':'启用'}}</el-button>
					 -->
					<el-button v-if="scope.row.status==0"  size="small" type="text"
						@click="toExamine(scope.row.id, 1)">通过</el-button>
					<el-button v-if="scope.row.status==0" size="small"
					 type="text" @click="toExamine(scope.row.id, 2)">驳回</el-button>
					　　　　
				</template>
				　　</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="storeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="storeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 店铺审核 -->
		<el-dialog style="float:rigin" title="审核" :visible.sync="editDialogVisible" width="35%"
			:closeOnClickModal="false" >
			
			<div class="app-container" v-if="auditType==2">
				<el-form ref="form" :model="form" :rules="mainFormRules" size="medium" >
					<el-form-item label="驳回原因:">
						<el-col :span="18">
							<el-input v-model="form.refuseReason" placeholder="请输入驳回原因" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button :loading="checkLoading" type="primary" v-if="auditType==2"
					@click="editStoreInfoCheck(storeId,2)">驳回</el-button>
				<el-button :loading="checkLoading" type="primary" v-if="auditType==1"
				@click="editStoreInfoCheck(storeId,1)">通过</el-button>
				
				<el-button @click="cannelPass">取 消</el-button>
			</div>
		</el-dialog>
		
		<!-- 禁用 或 启用 -->
		<el-dialog style="float:rigin" :title="formStatus.status ? '禁 用':'启 用'" :visible.sync="editStatusDialogVisible" width="35%"
			:closeOnClickModal="false" >
			<div class="app-container">
				<el-form ref="form" :model="formStatus" :rules="mainFormRules" size="medium">
					<el-form-item label="禁用说明:" v-show="formStatus.status">
						<el-col :span="18">
							<el-input v-model="formStatus.refuseReason" placeholder="请输入禁用说明" />
						</el-col>
					</el-form-item>
					
					<div style="text-align: center;">
						<el-button :loading="toStatusLoading" type="primary" @click="toStatus()">{{formStatus.status ? '禁 用':'启 用'}}
						</el-button>
						<el-button @click="editStatusDialogVisible = false">取 消</el-button>
					</div>
				</el-form>
			</div>
		</el-dialog>


		<!-- 编辑商家 -->
		<el-dialog :closeOnClickModal="false" style="float:rigin" :title="title" :visible.sync="dialogVisible" width="50%" >
			<div class="app-container" style="text-align: center;padding-right:80px">
				<el-form size="medium" label-width="120px">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<!-- <el-form-item label-width="100px" label="用户登录名:" class='tiny' cleartable style="margin-top: 22px;">
							<el-input style="width: 200px;" v-model="username" placeholder="请输入用户登录名"></el-input>
						</el-form-item>

						<el-button type="primary" @click="getUserList">搜索</el-button>
						<el-button type="primary" @click="username = ''">清空</el-button> -->
						<el-form-item  label="选择商家" >
							<el-select filterable v-model="storeInfo.storeId" placeholder="请输入商家" 
							clear  style="width:200px;"
								:remote-method="getUserList"
								:loading="storeLoading"
								remote
								:disabled="stoId == 0?false:true"
								reserve-keyword>
								<el-option v-for="item in accountList" :key="item.id" :value="item.id" :label="item.storeName">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item label="关联用户" v-else >
						
							<span v-if="storeInfo.username">{{storeInfo.username}}</span>
							
						</el-form-item> -->
						
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="项目名称" >
							<el-input type="text" style="width:200px" v-model="storeInfo.businessName" placeholder="请输入项目名称" />
						</el-form-item>

						<el-form-item label="企业名称" >
							<el-input type="text" style="width:200px" v-model="storeInfo.enterpriseName" placeholder="请输入店铺名称企业名称" />
						</el-form-item>
						
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="项目Logo" >
							<!-- 图片上传 -->
							<el-upload :class="{hide: store_logo.length>0}" :action="httpUrl" :on-preview="handlePictureCardPreview"
								:file-list="store_logo" :show-file-list="true" :limit="1" list-type="picture-card" :on-remove="handleRemove"
								:before-upload="beforeAvatarUpload" :on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					
					
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;"
					>
						<!-- 线下店铺经营时间 -->
						<!-- 线下店铺配送方式 -->
						
						<el-form-item label="注册资本(万元)" >
							<el-input type="text" style="width:200px" v-model="storeInfo.registeredCapital" placeholder="请输入注册资本(万元)" />
						</el-form-item>
						<el-form-item  label="注册资本单位" >
							<el-select filterable v-model="storeInfo.monetaryUnit"  placeholder="请选择" clear
							style="width:200px;">
								<el-option :key="1" :value="1" label="人民币"></el-option>
								<el-option :key="2" :value="2" label="港币"></el-option>
								<el-option :key="3" :value="3" label="美元"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;justify-content: space-between;">
						<el-form-item  label="所属行业" >
							<el-select v-model="storeInfo.industryAffiliation" multiple placeholder="请选择" style="width:606px">
								<el-option
								v-for="item in BusinessCategory"
								
								:label="item.typeName"
								:value="item.typeName">
								</el-option>
							</el-select>
						</el-form-item>
						
						
					</div>
					
					<div style="display: flex;justify-content: space-between;">
						<el-form-item  label="主营业务" >
							<el-select v-model="storeInfo.mainBusiness" multiple placeholder="请选择" style="width:606px">
								<el-option
								v-for="item in mainBusinessCategory"
								
								:label="item.typeName"
								:value="item.typeName">
								</el-option>
							</el-select>
						</el-form-item>
						
						
					</div>
					
				
					<el-form-item  label="经营范围" >
						<el-input type="textarea"  :rows="3" v-model="storeInfo.natureBusiness" style="width: 606px;" placeholder="请输入经营范围" />
						
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;" >
						<el-form-item label="联系人">
							<el-input type="text" v-model="storeInfo.contacts" style="width: 200px;" placeholder="请输入联系人" />
						</el-form-item>
						<el-form-item label="联系电话">
							<el-input type="text" v-model="storeInfo.contactNumber" style="width: 200px;" placeholder="请输入联系电话" />
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						
						<el-form-item label="法人" style="width:1200px;">
							<el-input type="text" v-model="storeInfo.legalPerson" style="width: 200px;" placeholder="请输入法人名称" />
						</el-form-item>
						<el-form-item label="注册资本(万元)" style="width:800px;">
							<el-input type="text" v-model="storeInfo.registeredCapital" style="width: 200px;" placeholder="请输入注册资本" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;"
					>
					<el-form-item label="身份证正面">
						<!-- bank_licence_image -->
						<el-upload :class="{hide: fileList.length>0}"  :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove1" :file-list="fileList" :show-file-list="true" :limit="1"
							:on-success="onSuccess1">
							<i class="el-icon-plus"></i>
						</el-upload>
					
					</el-form-item>
						<el-form-item label="身份证反面">
							<el-upload :class="{hide: fileListTwo.length>0}"  :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove1Two" :file-list="fileListTwo" :show-file-list="true" :limit="1"
								:on-success="onSuccess1Two">
								<i class="el-icon-plus"></i>
							</el-upload>
					
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="法人身份证号" style="width:1200px;">
							<el-input type="text" v-model="storeInfo.cardNo" style="width: 200px;" placeholder="请输入法人身份证号" />
						</el-form-item>
						<el-form-item label="排序" style="width:800px;">
							<el-input type="text" v-model="storeInfo.orders" style="width: 200px;" placeholder="请输入排序(数值越大越靠前)" />
						</el-form-item>
					</div>
					<el-form-item  label="税号" >
						<el-input type="text"  :rows="3" v-model="storeInfo.dutyParagraph" style="width: 606px;" placeholder="请输入税号" />
						
					</el-form-item>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item  label="设立时间" style="width:1200px;">
							 <el-date-picker
							      v-model="storeInfo.establishmentDate"
							      type="date"
								  
								  value-format="yyyy-MM-dd"
							      placeholder="选择日期" style="width: 200px;">
							    </el-date-picker>
							
						</el-form-item>
						<el-form-item label="地址" style="width:800px;">
							<el-input type="text" v-model="storeInfo.address" style="width: 200px;" placeholder="请输入详细地址" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item  label="年营收(万元)" style="width:1200px;">
							 <el-input type="text" v-model="storeInfo.businessIncome" style="width: 200px;" placeholder="请输入年度营业收入" />
							
						</el-form-item>
						<el-form-item label="同比增长(%)" style="width:800px;">
							<el-input type="text" v-model="storeInfo.businessIncomeRate" style="width: 200px;" placeholder="请输入增长比例" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item  label="净利润(万元)" style="width:1200px;">
							 <el-input type="text" v-model="storeInfo.netProfit" style="width: 200px;" placeholder="请输入年度营业收入" />
							
						</el-form-item>
						<el-form-item label="同比增长(%)" style="width:800px;">
							<el-input type="text" v-model="storeInfo.netProfitRate" style="width: 200px;" placeholder="请输入增长比例" />
						</el-form-item>
					</div>
					
					
					

					<div style="height: 500px;">
						
						<el-form-item label="企业介绍">
							<div id="lpc-quill" class="quill" style="height: 300px;">
								<el-upload  class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor style="height: 300px;" v-model="storeInfo.businessSituation" ref="myQuillEditor" class="editer" :options="editorOption"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
					<div style="height: 500px;"> 
						
						<el-form-item label="财务简况">
							<div id="lpc-quill" class="quill1" style="height: 300px;">
								<el-upload  class="upload-demo1" v-show="false" ref="upload1" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess1" :on-error="uploadError" />
								<quill-editor style="height: 300px;" v-model="storeInfo.financialOverview" ref="myQuillEditor1" class="editer" :options="editorOption1"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
					<div style="height: 500px;">
						
						<el-form-item label="IPO进程">
							<div id="lpc-quill" class="quill" style="height: 300px;">
								<el-upload  class="upload-demo2" v-show="false" ref="upload2" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess2" :on-error="uploadError" />
								<quill-editor style="height: 300px;" v-model="storeInfo.ipoProcess" ref="myQuillEditor2" class="editer" :options="editorOption2"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
					<div style="height: 500px;">
						
						<el-form-item label="市值评估">
							<div id="lpc-quill" class="quill" style="height: 300px;">
								<el-upload  class="upload-demo3" v-show="false" ref="upload3" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess3" :on-error="uploadError" />
								<quill-editor style="height: 300px;" v-model="storeInfo.marketValueAssessment" ref="myQuillEditor3" class="editer" :options="editorOption3"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button v-if="title=='新增'" type="primary" @click="sure" :loading="sureLoading">添 加</el-button>
				<el-button v-if="title=='编辑'" type="primary" @click="edit" :loading="editLoading">修 改</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>


		<!-- 查看店铺各种照片 -->
		<el-dialog title="照片" :visible.sync="showContentDialog" width="50%" :closeOnClickModal="false">
			<div>
				<div>
					<img style="width: 100%;" :src="storeInfo.storeLogo" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdFace" />
				</div>
				<div>
					<img style="width: 100%;" :src="storeInfo.legalIdBack" />
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 图片查看 -->
		<el-dialog :visible.sync="dialogImg" :closeOnClickModal="false" width="700px">
			<div style="text-align: center;">
				<img width="600px" style="width:600px;height:auto" :src="popupImageUrl">
			</div>
			<div style="height:30px"></div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogImg = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="查看详情" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div style="max-height:700px;overflow-y:scroll; overflow-x:hidden;">
				<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
				<div v-if="detailType == 2"
					style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
					<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
				</div>
			</div>
			<div style="text-align: center;margin-top:50px">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>


		
		<el-dialog :title="'['+poupStoreName+']'+' 商品列表'" :visible.sync="storeGoodsFlag" width="95%" :closeOnClickModal="false">
			<div>
				<el-tabs type="border-card" v-model="poupName" @change="tchange">
					
					<el-tab-pane label="商城商品" name="1">
						<el-form :inline="true" class="demo-form-inline" :model="findGoodInfo" style="margin: 20px 0px 0px 20px;">
							<el-form-item label="商品名称" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="findGoodInfo.goodsName" placeholder="请输入商品名称"></el-input>
							</el-form-item>
							<el-form-item label="商品编号" class='tiny' cleartable> 
								<el-input style="width: 200px;" v-model="findGoodInfo.goodsCode" placeholder="请输入商品编号"></el-input>
							</el-form-item>
							<el-form-item label="审核状态" class='tiny' cleartable>
								<el-select v-model="findGoodInfo.status" placeholder="请选择">
									<el-option key="0" label="待审核" :value="0">待审核</el-option>
									<el-option key="1" label="通 过" :value="1">通 过</el-option>
									<el-option key="2" label="驳 回" :value="2">驳 回</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="商品状态" class='tiny' cleartable>
								<el-select v-model="findGoodInfo.status" placeholder="请选择">
									<el-option key="0" label="下架" :value="0">下架</el-option>
									<el-option key="1" label="上架" :value="1">上架</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<template>
									<el-button type="primary" @click="searchGood">查询</el-button>
									<el-button @click="emptyOne">清空</el-button>
								</template>
							</el-form-item>
						</el-form>
						<div>
							<el-table :data="storeGoodsList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="goodLoadingOne"
								element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
								<el-table-column type="expand">
									<template slot-scope="props">
										<el-form label-position="left" inline class="demo-table-expand" label-width="150px">
											<el-form-item label="用户ID">
												<span>{{ props.row.userId?props.row.userId:'无' }}</span>
											</el-form-item>
											<el-form-item label="用户名">
												<span>{{ props.row.username?props.row.username:'无' }}</span>
											</el-form-item>
											<!-- <el-form-item label="供应商ID">
												<span>{{ props.row.storeId }}</span>
											</el-form-item> -->
											<el-form-item label="供应商名称">
												<span>{{ props.row.supplierName }}</span>
											</el-form-item>
											<el-form-item label="店铺名称">
												<span v-if="props.row.storeId!=0">{{ props.row.storeName }}</span>
												<span v-else>自营</span>
											</el-form-item>
											<el-form-item label="商品ID">
												<span>{{ props.row.id }}</span>
											</el-form-item>
											<el-form-item label="商品名称">
												<span>{{ props.row.goodsName }}</span>
											</el-form-item>
											<el-form-item label="商品编号">
												<span>{{ props.row.goodsCode?props.row.goodsCode:'无' }}</span>
											</el-form-item>
											<el-form-item label="分类名称">
												<span>{{ props.row.className ?
													props.row.classNameOne+'/'+props.row.classNameTwo+'/'+props.row.className:'无' }}</span>
											</el-form-item>
											<el-form-item label="市场价">
												<span>￥{{ props.row.marketPrice }}</span>
											</el-form-item>
											<!-- <el-form-item label="赠送积分">
												<span>{{ props.row.marketPrice }}</span>
											</el-form-item> -->
											<el-form-item label="零售价">
												<span>￥{{ props.row.price }}</span>
											</el-form-item>
											<el-form-item label="供货价">
												<span>￥{{ props.row.costPrice }}</span>
											</el-form-item>
											<el-form-item label="商品分类">
												<span v-if="props.row.isShopFil == 14">兑换商品</span>
												<span v-if="props.row.isShopFil == 16">共享商品</span>
											</el-form-item>
											<el-form-item label="是否为云链选品" v-if="stoId == 0">
												<span v-if="props.row.isCloud">是</span>
												<span v-else>否</span>
											</el-form-item>
											<el-form-item label="分销价" v-if="stoId == 0">
												<span>￥{{ props.row.agreementPrice || 0 }}</span>
											</el-form-item>
											<el-form-item label="运费">
												<span>￥{{ props.row.freightPrice }}</span>
											</el-form-item>
											<el-form-item label="排序级别">
												<span>{{ props.row.orderIndex }}</span>
											</el-form-item>
											<el-form-item label="商品简单描述">
												<span>{{ props.row.remark?props.row.remark:'无' }}</span>
											</el-form-item>
											<el-form-item v-if="props.row.authStatus == 2" label="驳回原因">
												<span>{{ props.row.rejected }}</span>
											</el-form-item>
											<el-form-item label="商品详细描述">
												<el-button size="small" type="text" @click="findDetail(props.row.detail,1)">点击查看</el-button>
											</el-form-item>
											<el-form-item label="商品图片">
												<el-button size="small" type="text" @click="findDetail(props.row.images,2)">点击查看</el-button>
											</el-form-item>
										</el-form>
									</template>
								</el-table-column>

								<el-table-column prop="id" label="商品ID" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="status" label="商品状态" align="center" :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<p v-if="scope.row.status==0">下架</p>
										<p v-if="scope.row.status==1">上架</p>
									</template>
								</el-table-column>
								<el-table-column prop="className" label="所属类别" align="center" :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<p>{{scope.row.className}}
											<!-- /{{scope.row.classNameOne}}/{{scope.row.classNameTwo}} -->
										</p>
									</template>
								</el-table-column>
								<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="salesSum" label="销量" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="costPrice" label="供应价" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="price" label="零售价" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="marketPrice" label="市场价" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<!-- <el-table-column prop="marketPrice" label="赠送积分" align="center" :show-overflow-tooltip="true">
								</el-table-column> -->
								<el-table-column prop="authStatus" label="审核状态" align="center" :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<!-- <p v-if="scope.row.authStatus==0">待审核</p>
										<p v-if="scope.row.authStatus==1">通 过</p>
										<p v-if="scope.row.authStatus==2">驳 回</p> -->
										<p v-if="scope.row.status==0" style="color:#E6A23C;font-weight: bold;">待审核</p>
										<p v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">通 过</p>
										<p v-if="scope.row.status==2" style="color:#F56C6C;font-weight: bold;">驳 回</p>
									</template>
								</el-table-column>
								<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
								</el-table-column>
							</el-table>
							<el-pagination style="margin: 20px 0px 20px;" background :current-page="storeGoodsList.pageNum"
								@current-change="pageChangeOne" layout="total, sizes, prev, pager, next, jumper" :total="storeGoodsList.total"
								@size-change="handleSizeChangeOne">
							</el-pagination>
						</div>
						
					</el-tab-pane>
					<el-tab-pane label="门店商品" name="2" v-if="storeTypeFlage==1">
						<el-form :inline="true" class="demo-form-inline" :model="findGoodInfoTwo" style="margin: 20px 0px 0px 20px;">
							<el-form-item label="商品名称" class='tiny' cleartable>
								<el-input style="width: 200px;" v-model="findGoodInfoTwo.goodsName" placeholder="请输入商品名称"></el-input>
							</el-form-item>
							<el-form-item label="商品编号" class='tiny' cleartable> 
								<el-input style="width: 200px;" v-model="findGoodInfoTwo.goodsCode" placeholder="请输入商品编号"></el-input>
							</el-form-item>
							<el-form-item label="审核状态" class='tiny' cleartable>
								<el-select v-model="findGoodInfoTwo.authStatus" placeholder="请选择">
									<el-option key="0" label="待审核" :value="0">待审核</el-option>
									<el-option key="1" label="通 过" :value="1">通 过</el-option>
									<el-option key="2" label="驳 回" :value="2">驳 回</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="商品状态" class='tiny' cleartable>
								<el-select v-model="findGoodInfoTwo.status" placeholder="请选择">
									<el-option key="0" label="下架" :value="0">下架</el-option>
									<el-option key="1" label="上架" :value="1">上架</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<template>
									<el-button type="primary" @click="searchGoodTwo">查询</el-button>
									<el-button @click="emptyTwo">清空</el-button>
								</template>
							</el-form-item>
						</el-form>
						<div>
							<el-table :data="storeGoodsListTwo.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="goodLoadingTwo"
								element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

								<el-table-column type="expand">
									<template slot-scope="props">
										<el-form label-position="left" inline class="demo-table-expand">
											<el-form-item label="用户ID">
												<span>{{ props.row.userId?props.row.userId:'无' }}</span>
											</el-form-item>
											<el-form-item label="用户名">
												<span>{{ props.row.username?props.row.username:'无' }}</span>
											</el-form-item>
										
											<el-form-item label="店铺名称">
												<span>{{ props.row.storeName }}</span>
										
											</el-form-item>
											<el-form-item label="商品ID">
												<span>{{ props.row.id }}</span>
											</el-form-item>
											<el-form-item label="商品名称">
												<span>{{ props.row.goodsName }}</span>
											</el-form-item>
											<el-form-item label="商品编号">
												<span>{{ props.row.goodsCode?props.row.goodsCode:'无' }}</span>
											</el-form-item>
											<el-form-item label="分类名称">
												<span>{{ props.row.className }}</span>
											</el-form-item>
											<el-form-item label="市场价">
												<span>{{ props.row.marketPrice }}</span>
											</el-form-item>
											
											<el-form-item label="零售价">
												<span>{{ props.row.price }}</span>
											</el-form-item>
											<el-form-item label="供货价">
												<span>{{ props.row.costPrice }}</span>
											</el-form-item>
											
											<el-form-item label="排序级别">
												<span>{{ props.row.orderIndex }}</span>
											</el-form-item>
											<el-form-item label="商品简单描述">
												<span>{{ props.row.remark?props.row.remark:'无' }}</span>
											</el-form-item>
											<el-form-item v-if="props.row.authStatus == 2" label="驳回原因">
												<span>{{ props.row.reasonRejection }}</span>
											</el-form-item>
											<el-form-item label="商品详细描述">
												<el-button size="small" type="text" @click="findDetail(props.row.detail,1)">点击查看</el-button>
											</el-form-item>
											<el-form-item label="商品图片">
												<el-button size="small" type="text" @click="findDetail(props.row.images,2)">点击查看</el-button>
											</el-form-item>
										</el-form>
									</template>
								</el-table-column>

								<el-table-column prop="id" label="商品ID" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="status" label="商品状态" align="center" :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<p v-if="scope.row.status==0" style="color:#F56C6C;">下架</p>
										<p v-if="scope.row.status==1" style="color:#67C23A;">上架</p>
									</template>
								</el-table-column>
								<el-table-column prop="className" label="所属类别" align="center" :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<p>{{scope.row.className}}
											<!-- /{{scope.row.classNameOne}}/{{scope.row.classNameTwo}} -->
										</p>
									</template>
								</el-table-column>
								<el-table-column prop="pickupType" label="取货方式" align="center" :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<p v-if="scope.row.pickupType == 1">到店核销</p>
									</template>
								</el-table-column>
								
								<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="salesSum" label="销量" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="price" label="价格" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="marketPrice" label="市场价" align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<!-- <el-table-column prop="marketPrice" label="赠送积分" align="center" :show-overflow-tooltip="true">
								</el-table-column> -->
								<el-table-column prop="authStatus" label="审核状态" align="center" :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<!-- <p v-if="scope.row.authStatus==0">待审核</p>
										<p v-if="scope.row.authStatus==1">通 过</p>
										<p v-if="scope.row.authStatus==2">驳 回</p> -->
										<p v-if="scope.row.status==0" style="color:#E6A23C;font-weight: bold;">待审核</p>
										<p v-if="scope.row.status==1" style="color:#67C23A;font-weight: bold;">通 过</p>
										<p v-if="scope.row.status==2" style="color:#F56C6C;font-weight: bold;">驳 回</p>
									</template>
								</el-table-column>
								<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
								</el-table-column>
								<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
								</el-table-column>
							</el-table>
							<el-pagination style="margin: 20px 0px 20px;" background :current-page="storeGoodsListTwo.pageNum"
								@current-change="pageChangeTwo" layout="total, sizes, prev, pager, next, jumper" :total="storeGoodsListTwo.total"
								@size-change="handleSizeChangeTwo">
							</el-pagination>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="storeGoodsFlag = false">关闭</el-button>
			</span>
		</el-dialog>


		<el-dialog title="资产变动记录" :visible.sync="storeZCFlage" width="70%" center :closeOnClickModal="false">
			<div>
				<div style="display: flex;align-content: center;align-items: center;"> 
					<div style="display: flex;align-content: center;align-items: center;">
						<span>LOGO：</span>
						<img :src="storeZCInfo.storeLogo" style="width: 80px;height: 80px;border-radius: 10px;" />
					</div>
					<div style="display: flex;margin: 0 40px;">
						<span>店铺名称：</span>
						<div>{{ storeZCInfo.storeName}}</div>
						
					</div>
					<div style="display: flex;">
						<span>店铺属性：</span>
						<p v-if="storeZCInfo.storeType == 0">线上店铺</p>
						<p v-if="storeZCInfo.storeType == 1">线下店铺</p>
					</div>
				</div>
				

				<div style="margin: 20px 0;">
					<el-form :inline="true" class="demo-form-inline" :model="searchStoreZCInfo" style="margin: 20px 0px 0px 20px;">
						<el-form-item label="变动类别" class='tiny'>
							<el-select v-model="searchStoreZCInfo.changeType" placeholder="请选择">
								<el-option key="-1" label="全部" :value="null">全部</el-option>

								<el-option key="0" label="支出" :value="-1"></el-option>
								<el-option key="1" label="收入" :value="1"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="变动类型" class='tiny'>
						<el-select style="width: 200px;" filterable  v-model="searchStoreZCInfo.source" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option v-for="item in typeList" :key="item.id" :value="item.recordTypeKey"
								:label="item.recordTypeName">
							</el-option>
						</el-select>
					</el-form-item>

						<el-form-item label="时间">
							<div class="block">
								<el-date-picker v-model="searchStoreZCInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
									type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
									:default-time="['00:00:00', '23:59:59']">
								</el-date-picker>
							</div>
						</el-form-item>

						<el-form-item>
							<template>
								<el-button type="primary" @click="searchStoreZCClick">查询</el-button>
								<el-button @click="emptyStoreZC">清空</el-button>
							</template>
						</el-form-item>
					</el-form>
				</div>

				<el-table class="tables" :data="storeRecordList.list" stripe style="width: 100%;" 
				:header-cell-style="headClass" v-loading="storeRecordLoading" element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading">
					<el-table-column label="变动类别" prop="changeType" align="center"  :formatter="changeNull">
						<template slot-scope="scope">
							<p v-if="scope.row.changeType==-1">支出</p>
							<p v-if="scope.row.changeType==1">收入</p>
						</template>
					</el-table-column>
					<el-table-column prop="recordTypeName" label="变动类型" align="center" :formatter="changeNull">
					</el-table-column>
					<el-table-column prop="beforeAmount" label="变动前" align="center"  :formatter="changeNull">
						<template v-slot="scope">
							<span>{{scope.row.beforeAmount}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="amount" label="变动金额" align="center" :formatter="changeNull">
					</el-table-column>
					<el-table-column prop="afterAmount" label="变动后" align="center" :formatter="changeNull">
						<template v-slot="scope">
							<span>{{scope.row.afterAmount}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="memo" label="备注" align="center" :formatter="changeNull" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="operBy" label="操作人" align="center" :formatter="changeNull" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="createTime" label="创建时间" width="" align="center" :show-overflow-tooltip="true" >
					</el-table-column>
				</el-table>
				<div style="display: flex;align-items: center;justify-content: space-between;">
					<el-pagination style="margin: 20px;" background :current-page="storeRecordList.pageNum"
						@current-change="pageChangeStoreZC" @size-change="handleSizeChangeStoreZC"
						layout="total, sizes, prev, pager, next, jumper" :total="storeRecordList.total">
					</el-pagination>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="storeZCFlage = false">关闭</el-button>
			</span>
		</el-dialog>	

	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('store');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				httpUrl: urls,
				loading: false,
				storeList: [{}], //列表
				dialogVisible: false, // 审核
				editDialogVisible: false, // 编辑
				showContentDialog: false, //查看证件照片
				editStatusDialogVisible: false,//禁用或启用
				formStatus:{},
				accountList: [],
				username: '',
				regionId:'',
				storeInfo: {
					userId: "",
					isHot: "",
					storeLogo: "",
					storeName: "",
					storeIntro: "",
					type: "",
					linkUser: "",
					phone: "",
					legalIdNumber: "",
					legalIdFace: "",
					legalIdBack: "",
					provinceId: "",
					cityId: "",
					regionId: "",
					province: "",
					city: "",
					area: "",
					address: "",
					storeType:'', 
				},
				store_logo: [], //店铺logo
				provinceList: {},
				cityList: {},
				districtList: {},
				storeId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					isHot: '',
					checkState: '',
					status: '',
					storeType: ''

				},
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},
				editorOption1: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo1 input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},
				editorOption2: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo2 input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},
				editorOption3: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function (value) {
									// console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo3 input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},
				
						},
					},
					theme: "snow",
				},
				dialogVisibleDetails:false, //logo查看弹窗
				storeLoading: false,
				auditInfo: {}, //店铺审核信息
				auditType: '', //店铺审核类型

				licensePhoto:[], //店铺营业执照
				fileList: [], //证件照片
				fileListTwo: [], //店铺照片

				dialogImg:false,
				popupImageUrl:'',

				BusinessCategory:[], //经营类别
				mainBusinessCategory:[],
				storeGoodsFlag: false,
				poupName: '1',
				poupStoreName: '',
				poupStoreID: 0,

				storeTypeFlage: 0,
				findGoodInfo: {},
				storeGoodsList: [],
				goodLoadingOne: false,

				findGoodInfoTwo: {},
				storeGoodsListTwo: [],
				goodLoadingTwo: true,
				pageGood: {
					pageNum: 1,
					pageSize: 10,

					pageNumTwo: 1,
					pageSizeTwo: 10
				},
				

				detail: '',
				images: [],
				detailType: 0,

				stoId: '', //用户ID

				sureLoading: false,
				editLoading: false,


				storeZCFlage: false,
				storeRecordList: {},
				storeRecordLoading: false,
				pageStoreRecord: {
					pageNum: 1,
					pageSize: 10,
				},
				storeZCInfo: {},
				searchStoreZCInfo: {
					changeType: null,
					timer: [],
					source: ''
				},
				typeList: [],

				checkLoading: false, //审核
				toStatusLoading: false, //禁用或启用
			};
		},

		methods: {
			tchange(e){
				console.log(e);
			},
			toStoreZC(row){  //资产变动记录
				this.storeZCInfo = row;
				this.storeZCFlage = true;
				this.storeRecordList = {};
				this.searchStoreZCInfo =  {
					changeType: null
				};
				this.pageStoreRecord.pageNum = 1;
				this.pageStoreRecord.pageSize = 10;
				this.getStoreRecordList();
				this.getRecordTypeList();
			},
			getRecordTypeList() {
				let data = {}
				this.$api.getRecordTypeList(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					// console.log('数据---',res )
					if (res.state == 'success') {
						this.typeList = res.data
					}
				})
			},
			emptyStoreZC() {
				this.searchStoreZCInfo = {}
			},
			searchStoreZCClick() {
				this.pageStoreRecord.pageNum = 1;
				this.getStoreRecordList();
			},
			pageChangeStoreZC(data) {
				this.pageStoreRecord.pageNum = data
				this.getStoreRecordList()
			},
			handleSizeChangeStoreZC(val) {
				this.pageStoreRecord.pageSize = val
				this.getStoreRecordList()
			},
			getStoreRecordList(){
				let data = {
					storeId: this.storeZCInfo.id,

					pageNum: this.pageStoreRecord.pageNum,
					pageSize: this.pageStoreRecord.pageSize,

					startTime: this.searchStoreZCInfo.timer ? this.searchStoreZCInfo.timer[0] : "",
                    endTime:  this.searchStoreZCInfo.timer ? this.searchStoreZCInfo.timer[1] : "" ,
					changeType: this.searchStoreZCInfo.changeType,
					source: this.searchStoreZCInfo.source,
				}
				this.$api.storeAssetChangesList(data).then((res) => {
					if (res.state == 'success') {
						this.storeRecordList = res.data
					} else {
						this.$message.error(res.message)
					}
					this.storeRecordLoading = false
				})
			},
			storeGoodsDialog(item){ //店铺商品弹窗
				this.storeGoodsList = [];
				this.storeGoodsListTwo = [];
				this.findGoodInfo = {};
				this.findGoodInfoTwo = {};
				this.poupName = '1';

				this.storeTypeFlage = item.storeType;
				this.poupStoreID = item.id;
				this.poupStoreName = item.storeName;
				this.storeGoodsFlag=true;

				this.getStoreGoodsList()
				if(item.storeType==1){
					this.getStoreGoodsListTwo();
				}
			},
			searchGood(){ //条件查询商品
				this.pageGood.pageNum = 1
				this.getStoreGoodsList();
			},
			emptyOne(){
				this.findGoodInfo = {}
			},
			pageChangeOne(val){
				this.pageGood.pageNum = val
				this.getStoreGoodsList()
			},
			handleSizeChangeOne(val){
				this.pageGood.pageSize = val
				this.getStoreGoodsList()
			},
			getStoreGoodsList() {
				this.goodLoadingOne = true
				this.findGoodInfo.orderType = 3;
				this.findGoodInfo.storeId = this.poupStoreID;
				this.findGoodInfo.pageNum = this.pageGood.pageNum;
				this.findGoodInfo.pageSize = this.pageGood.pageSize;
				this.$api.getStoreGoodsList({...this.findGoodInfo,goodsType:1}).then((res) => { //商品列表
					if (res.state == 'success') {
						this.storeGoodsList = res.data
						this.goodLoadingOne = false
					}
				})
			},

			searchGoodTwo(){ //条件查询商品
				this.pageGood.pageNumTwo = 1
				this.getStoreGoodsListTwo();
			},
			emptyTwo(){
				this.findGoodInfoTwo = {}
			},
			pageChangeTwo(val){
				this.pageGood.pageNumTwo = val
				this.getStoreGoodsListTwo()
			},
			handleSizeChangeTwo(val){
				this.pageGood.pageSizeTwo = val
				this.getStoreGoodsListTwo()
			},
			getStoreGoodsListTwo() {
				this.goodLoadingTwo = true
				this.findGoodInfoTwo.storeId = this.poupStoreID;
				this.findGoodInfoTwo.pageNum = this.pageGood.pageNumTwo;
				this.findGoodInfoTwo.pageSize = this.pageGood.pageNumTwo;
				this.$api.ssGoodsList(this.findGoodInfoTwo).then((res) => { //商品列表
					if (res.state == 'success') {
						this.storeGoodsListTwo = res.data
						this.goodLoadingTwo = false
					}
				})
			},

			getBusinessCategoryList(){
				let data={
					pageSize: 100,
					pageNum: 1,
					
				}
				this.$api.findipoBusinessNature(data).then((res) => {
						if (res.state == 'success') {
							// console.log('134--', res.data)
							this.BusinessCategory = res.data.list
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
			},
			getmainBusinessCategoryList(){
				let data={
					pageSize: 100,
					pageNum: 1,
					
				}
				this.$api.findipoBusinessClassify(data).then((res) => {
						if (res.state == 'success') {
							// console.log('134--', res.data)
							this.mainBusinessCategory = res.data.list
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
			},
			clickImg(e) { //图片查看
				this.popupImageUrl = e;
				this.dialogImg = true;
			},
			//上传店铺logo
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.store_logo.push({
					url: response.message
				})
			},
			handleRemove(file, fileList) {
				this.store_logo = [];
			},

			onSuccess1(response, file) {
				// console.log(response)
				this.fileList.push({
					"url": response.message
				})
				// console.log("asda", this.fileList)
			},
			handleRemove1(file, fileList) {
				if (file.response) {
					this.fileList.remove(file.response.message);
				}
				this.fileList.remove(file);
			},
			onSuccess1Two(response, file) {
				// console.log(response)
				this.fileListTwo.push({
					"url": response.message
				})
			},
			handleRemove1Two(file, fileList) {
				if (file.response) {
					this.fileListTwo.remove(file.response.message);
				}
				this.fileListTwo.remove(file);
			},
		
			handleRemoveTwo(file, fileList) {
				this.licensePhoto = [];
			},
			handlePictureCardPreview(file) {
				// this.dialogImageUrl = file.url;
				// this.dialogVisibleImg = true;

				this.popupImageUrl = file.url;
				this.dialogImg = true;
			},
			

			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},

			toExamine(id,num){ // 查询店铺详细信息
				//审核驳回弹窗打开
				this.form.refuseReason = ""; //驳回原因
					
				this.auditType = num; //审核类型
				this.auditInfo = {}; //审核数据信息

				this.storeId = id
				this.$api.getStoreId(this.storeId).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.auditInfo = res.data;
						// console.log('审核信息1---',this.auditInfo )
						// this.auditInfo.bankLicenceImage = res.data.bankLicenceImage.split(',')
						// this.auditInfo.storeImages = res.data.storeImages.split(',')
						if(res.data.bankLicenceImage){ //证件照片
							this.auditInfo.bankLicenceImage = res.data.bankLicenceImage.split(',')
						}
						if(res.data.storeImages){  //店铺照片
							this.auditInfo.storeImages = res.data.storeImages.split(',')
						}
						// console.log('审核信息2---',this.auditInfo )
						this.editDialogVisible = true;
					}
				})
			},
			getUserList(e) {
				this.storeLoading = true
				//查询用户账号
				if (e.length >= 2) {
					var data = {
						storeName: e
					}
					this.$api.getStoreNameList(data).then((res) => {
						if (res.state == 'success') {
							if (res.data && res.data.length) {
								// this.$message({
								// 	message: '查询成功，请选择用户！',
								// 	type: 'success'
								// });
								this.accountList = res.data
							} else {
								this.$message.error("未查询到用户");
							}
						}else{
							this.$message.error(res.message);
						}
						this.storeLoading = false
					})
				}else{
					this.accountList = []
				}

				
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreList()
			},
			showFile(info) {
				this.showContentDialog = true
				this.storeInfo.storeLogo = info.storeLogo
				this.storeInfo.legalIdFace = info.legalIdFace
				this.storeInfo.legalIdBack = info.legalIdBack
			},
			//店铺提交审核
			editStoreInfoCheck(id, status) {
				this.checkLoading = true;
				if (status == 2) {
					//通过驳回
					var data = {
						id: this.storeId,
						status: status,
						reason: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						status: status
					}
				}
				this.$api.updateStatusBusiness(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreList()
					} else {
						this.$message.error(res.message);
					}
					this.checkLoading = false;
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			
		
			// 店铺编辑弹窗
			dialogVisibleFun(it) {
				this.storeInfo = {}
				this.storeId = ""
				this.regionId = '';
				this.store_logo = [];
				this.licensePhoto = [];
				this.fileList = [];
				this.fileListTwo = [];

				if (it.id) {
					this.$api.findByIdipoBusiness(it.id).then(res=>{
						this.storeInfo = res.data
						this.storeInfo.mainBusiness=this.storeInfo.mainBusiness.split(',')
						this.storeInfo.industryAffiliation=this.storeInfo.industryAffiliation.split(',')
						
						if(this.storeInfo.businessLogo){
							this.store_logo.push({
								url: this.storeInfo.businessLogo
							})
						}else{
							this.store_logo = []
						}
						if(this.storeInfo.positiveImage){
							this.fileList.push({
								url: this.storeInfo.positiveImage
							})
						}else{
							this.fileList = []
						}
						if(this.storeInfo.reverseImage){
							this.fileListTwo.push({
								url: this.storeInfo.reverseImage
							})
						}else{
							this.fileListTwo = []
						}
						this.storeId = it.id
						console.log(this.store_logo);
					})
					
					
				} 
				this.dialogVisible = true;
			},
			//新增店铺
			sure() {
				// this.storeInfo.storeLogo = this.logo; //店铺logo
				this.storeInfo.regionId = this.regionId;
				if(this.licensePhoto.length == 1){
					this.storeInfo.licensePhoto = this.licensePhoto[0].url; //营业执照
				}
				if(this.store_logo.length == 1){
					this.storeInfo.storeLogo = this.store_logo[0].url; //营业执照
				}
				// this.storeInfo.storeLogo = this.store_logo[0].url; //logo
				
				if(Array.isArray(this.storeInfo.storeClassId)){
					// console.log('经营类目---', this.storeInfo.storeClassId)
					this.storeInfo.storeClassId = this.storeInfo.storeClassId.join(',');
				}
				let arrOne = [];
				
				this.fileList.map(item => { //证件照片
					arrOne.push(item.url)

				})
				this.storeInfo.bankLicenceImage = arrOne.join(",")
				
				if(this.storeInfo.storeType == 1){
					let arrTwo = [];
					this.storeInfo.businessHours = this.storeInfo.businessHours.join("-"); //营业时间
					this.fileListTwo.map(item => { //店铺照片
						arrTwo.push(item.url)
					})
					this.storeInfo.storeImages = arrTwo.join(",")
				}

				// console.log('新增数据---',this.storeInfo)

				this.sureLoading = true;
				this.$api.addStore(this.storeInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});

						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
						
					}
					this.sureLoading = false;
				})

			},
			//编辑
			edit() {				
				
				console.log(this.storeInfo.mainBusiness);
				
				if(this.store_logo.length == 1){
					this.storeInfo.businessLogo = this.store_logo[0].url; //营业执照
				}
				if(this.fileList.length == 1){
					this.storeInfo.positiveImage = this.fileList[0].url; //营业执照
				}
				if(this.fileListTwo.length == 1){
					this.storeInfo.reverseImage = this.fileListTwo[0].url; //营业执照
				}
				this.storeInfo.mainBusiness=this.storeInfo.mainBusiness.join(',') 
				this.storeInfo.industryAffiliation=this.storeInfo.industryAffiliation.join(',')
			

				this.editLoading = true;
				// console.log('编辑数据---', data)
				this.$api.updateipoBusiness({...this.storeInfo}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreList();
					} else {
						this.$message.error(res.message);
						this.storeInfo.mainBusiness=this.storeInfo.mainBusiness.split(',')
						this.storeInfo.industryAffiliation=this.storeInfo.industryAffiliation.split(',')
					}
					this.editLoading = false;
				})
			},
			editStatusShow(store){
				this.editStatusDialogVisible=true;
				this.formStatus=store;
			},
			//禁用启用
			toStatus() {
				this.toStatusLoading = true;
				let str;
				this.$api.editStoreBlockUpOrStartUsing(this.formStatus).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreList();
						this.editStatusDialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.toStatusLoading = false;
				})
				// if (this.formStatus == 0) {
				// 	str = "此操作将启用该店铺账号, 是否继续?"
				// } else {
				// 	str = "此操作将禁用该店铺账号, 是否继续?"
				// }
				// this.$confirm(str, '提示', {
				// 	confirmButtonText: '确定',
          		// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	console.log('点击了确定')
				// 	that.$api.editStoreBlockUpOrStartUsing(that.formStatus).then((res) => {
				// 		if (res.state == 'success') {
				// 			that.$message({
				// 				message: res.message,
				// 				type: 'success'
				// 			});
				// 			that.getStoreList();
				// 			that.editStatusDialogVisible = false;
				// 		} else {
				// 			that.$message.error(res.message);
				// 		}
				// 	})
				// }).catch(() => {
				// 	this.$message({
				// 		type: 'info',
				// 		message: '已取消'
				// 	});
				// });
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreList()
			},
			getStoreList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					 ...this.searchInfo,
					
				}

				this.$api.findListipoBusiness(data).then((res) => { //管理列表
					// console.log('店铺管理列表:', res.data.list[0]);
					if (res.state == 'success') {
						this.storeList = res.data
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},

			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdFace = res.data
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.data
				})
			},

			// 上传店铺logo点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传店铺logo上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			
			// 上传营业执照点击文件触发
			handlePreviewTwo(file) {
				// console.log(file)
			},
			// 上传营业执照 上传图片前，筛选
			beforeAvatarUploadTwo(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				let imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			//上传营业执照
			onSuccessTwo(response, file, fileList) {
				// console.log(response);
				this.licensePhoto.push({
					url : response.message
				});
			},

			upScuccess(res, file) {
				console.log(res,1);
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			upScuccess1(res, file) {
				console.log(res,2);
				const quill = this.$refs.myQuillEditor1.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			upScuccess2(res, file) {
				console.log(res);
				const quill = this.$refs.myQuillEditor2.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			upScuccess3(res, file) {
				console.log(res);
				const quill = this.$refs.myQuillEditor3.quill;
				if (res.state == "success" && res.message !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				console.log(editor);
			},
			logInUserInfo(){ //查询登录人信息
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						// console.log('登录人信息---', res.data )
						// supplierId(有值就是供应商)
						this.stoId = res.data.storeId; // storeId：0(平台)   
					}
				})
				
			}
		},
		created() {
			this.getStoreList();
			//查询省
			this.$api.getStoreNameList({}).then((res) => {
				if (res.state == 'success') {
					if (res.data && res.data.length) {
						// this.$message({
						// 	message: '查询成功，请选择用户！',
						// 	type: 'success'
						// });
						this.accountList = res.data
					} else {
						this.$message.error("未查询到用户");
					}
				}else{
					this.$message.error(res.message);
				}
			})
			this.getBusinessCategoryList();
			this.getmainBusinessCategoryList()
			this.logInUserInfo()
		}

	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 90px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>